define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SmaService = void 0;
    class SmaService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("Sma", httpProtocol, hostName, serviceName, proxyUrl);
        }
        createSpecialManagementArea(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("CreateSpecialManagementArea", p, (json) => {
                return json;
            });
        }
        persistSpecialManagementArea(sma) {
            let p = {};
            p.sma = sma;
            return this.post("PersistSpecialManagementArea", p, (json) => {
                return json;
            });
        }
        readSpecialManagementArea(id) {
            let p = {};
            p.id = id;
            return this.post("ReadSpecialManagementArea", p, (json) => {
                return json;
            });
        }
        updateSmaOnGeometryChange(sma) {
            let p = {};
            p.sma = sma;
            return this.post("UpdateSmaOnGeometryChange", p, (json) => {
                return json;
            });
        }
        validateSpecialManagementArea(sma) {
            let p = {};
            p.sma = sma;
            return this.post("ValidateSpecialManagementArea", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.SmaService = SmaService;
});
